// extracted by mini-css-extract-plugin
export default {"wrapper":"report-list-block-module--wrapper--8a285","innerWrapper":"report-list-block-module--innerWrapper--63898","link":"report-list-block-module--link--1f3a5"};